import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NotesComponent } from 'src/app/components/notes/notes.component';
import { TransactionHistoryComponent } from 'src/app/components/transaction-history/transaction-history';
import { Case } from 'src/app/models/case';
import { MemberDto } from 'src/app/models/member-dto';
import { ServiceRequest } from 'src/app/models/service.request';

import { MailMessagesComponent } from 'src/app/options/requests/drawer/mailmessages/mailmessages.component';
import { PastAssistanceComponent } from 'src/app/options/requests/drawer/pastassistance/pastassistance.component';
import { dataRecord } from 'src/app/options/requests/globalsearch/globalsearch.component';
import { CaseDetailsComponent } from 'src/app/options/common-tabs/case-details/case-details.component';
import { MembersComponent } from 'src/app/options/common-tabs/members/members.component';
import { QualificationResponsesComponent } from 'src/app/options/common-tabs/qualification-responses/qualification-responses.component';
import { RequestSummaryTabComponent } from 'src/app/options/requests/tabs/request-summary-tab/request-summary-tab.component';
import { AgenciesService } from 'src/app/services/agencies.service';
import { AuthService } from 'src/app/services/authservice/auth.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { Settings } from 'src/app/services/settings';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { UserService } from 'src/app/services/user.service';
import { CaseRequestsListComponent } from "../../../common-tabs/case-requests-list/case-requests-list.component";
import { CaseDocumentsComponent } from "../../../common-tabs/case-documents/case-documents.component";
import {
	CaseavatarpreviewComponent
} from "../../../common-tabs/case-documents/dialogs/caseavatarpreview/caseavatarpreview.component";


@Component({
	selector: 'app-case-details-dialog',
	templateUrl: './case-details-dialog.component.html',
	styleUrls: ['./case-details-dialog.component.css']
})
export class CaseDetailsDialogComponent {

	public propContainerState: boolean | null = false;  /** set to false ***/
	public visiblePropertiesTab: boolean | null = true;
	public membersList: any;
	public advocateFlag: boolean = false;
	public advocate: any;

	showHouseholdTab = false;
	selectedCaseId = 0;
	public selectedDrawTabLabel = '';
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabLabel = 'Case';
	public id: any | null = '';
	public description: any | null = '';
	public activeStatus: any | null = '';
	public busyCursor: boolean | null = false;

	public showDrawer: boolean = false;
	public showList: Array<dataRecord>;
	public showStatusList: Array<dataRecord>;

	public strCaseNumber = '';
	public strCaseStatus = '';
	public strApplicant = '';
	public strDaysOpen = '';

	public placeHolderURL: string = '/assets/profile-img-generic.png';
	public selectedFile: any;
	public valFilePath: any;
	public base64textStringAvatar: string;
	public loading = false;
	public imageAvatarFlag = false;
	public avatarURL = '';
	public visiblePreviewCaseAvatarDialog = false;
	public primaryAgencyFlag: boolean = false;
	public agencyId: number = null;
	public readOnlyFlag: boolean = false;
	showCaseAvatar = false;
	showMembersTab = true;
	showDocumentsTab = true;
	showCaseRequestsTab = true;
	showActivityTab = true;
	showQualificationsTab = true;

	showNotesTab = true;
	showEmailsTab = true;
	showPastAssistanceTab = true;

	public selectedRecord: Case;

	/*** Drawer Children ***/
	@ViewChild('pastAssistance', { static: false }) pastAssistance: PastAssistanceComponent;
	@ViewChild('notes', { static: false }) notes: NotesComponent;
	@ViewChild('mailMessages', { static: false }) mailMessages: MailMessagesComponent;

	@ViewChild('history', { static: false }) history: TransactionHistoryComponent;
	@ViewChild('casedetails', { static: false }) casedetails: CaseDetailsComponent;
	@ViewChild('members', { static: false }) members: MembersComponent;
	@ViewChild('casedocuments', { static: false }) casedocuments: CaseDocumentsComponent;
	@ViewChild('requests', { static: false }) requestsTab: CaseRequestsListComponent;
	@ViewChild('qualifications', { static: false }) qualifications: QualificationResponsesComponent;
	@ViewChild('previewCaseAvatar', { static: false }) previewCaseAvatar: CaseavatarpreviewComponent;

	@Output() editEvent = new EventEmitter<any>();

	@Input() set selectedId(caseId: number) {
		this.selectedCaseId = caseId;

		/** get my agency Id **/
		this.agencyId = Settings.getInstance().loggedInUser.agencyId;
		this.onShowHandler();
	}

	constructor(public serviceRequestsService: ServiceRequestsService, private txService: TransactionHistoryService,
		public agenciesService: AgenciesService, private serviceDefService: ServiceDefService, private authService: AuthService, private userService: UserService) {
		this.selectedRecord = new Case();
		this.showDrawer = true;
	}

	public ngOnInit() {
		this.readOnlyFlag = !Settings.getInstance().hasPrivilege('CLIENT_EDIT', "EXECUTE");
		this.showCaseAvatar = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_AVATAR', "SHOW");

		this.showDocumentsTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_DOCUMENTS', "SHOW");
		this.showActivityTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_ACTIVITY', "SHOW");
		this.showCaseRequestsTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CASE_REQUESTS', "SHOW");
		this.showQualificationsTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS', "SHOW");
		this.showMembersTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_MEMBERS', "SHOW");

		this.showPastAssistanceTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE', "SHOW");
		this.showNotesTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES', "SHOW");
		this.showEmailsTab = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_EMAILS', "SHOW");

		
		if (this.showPastAssistanceTab) {
			this.selectedDrawTabLabel = 'Past Assistance';
		} else if (this.showNotesTab) {
			this.selectedDrawTabLabel = 'Notes';
		} else if (this.showEmailsTab) {
			this.selectedDrawTabLabel = 'Emails';
		}
	}

	public onShowHandler() {
		if (!this.selectedCaseId || this.selectedCaseId < 1) {
			return;
		}
		this.serviceRequestsService.getCaseById(this.selectedCaseId).subscribe(
			(result) => {
				this.selectedRecord = result;
				if (this.selectedRecord.id > 0) {
					this.queryMemberRecords();
				}
				else {
					this.displayDetail(this.selectedRecord);
					this.doLoadAvatarImage();
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching Case');
			});
	}
	public queryMemberRecords(): void {
		if (!this.selectedRecord || !this.selectedRecord.id || this.selectedRecord.id < 1) {
			return;
		}
		this.membersList = [];
		this.advocateFlag = false;
		this.advocate = null;

		this.serviceRequestsService.getHouseholdMembersByCaseId(this.selectedRecord.id).subscribe(
			(results) => {
				this.membersList = results;
				const advIdx = this.membersList.findIndex(s => s.relationship === 'Advocate');
				if (advIdx > -1) {
					this.advocateFlag = true;
					this.advocate = this.membersList[advIdx];
				}
				this.displayDetail(this.selectedRecord);
				this.doLoadAvatarImage();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching Members');
			});
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
		/** if the drawer is open - then select the data for the selected record if chosen **/
		if ((this.propContainerState === true) && (this.selectedCaseId > 0)) {
			this.displayDrawerData();
		}
	}
	public doDrawerTabChange(event: any): void {
		const tabLabel = event.tab.textLabel;
		this.selectedDrawTabLabel = tabLabel;
		this.displayDrawerData();
	}
	public displayDrawerData(): void {

		switch (this.selectedDrawTabLabel) {
			case 'Past Assistance':
				if (this.pastAssistance === undefined) {
					return;
				}
				this.pastAssistance.onShowHandler(this.selectedCaseId);
				break;
			case 'Notes':
				this.notes.parentId = this.selectedRecord.id;
				this.notes.onShowHandler();
				break;
			case 'Email':
				this.mailMessages.onShowHandler();
				break;
		}
	}
	public doTabChange(event): void {
		const tabLabel = event.tab.textLabel;
		this.selectedTabLabel = tabLabel;

		if (this.selectedRecord) {
			this.displayDetail(this.selectedRecord);
		}
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}

	public displayDetail(record: Case) {

		if (record === undefined) {
			return;
		}
		this.strCaseNumber = record.caseNumber;
		const firstName = record.firstName || '';
		const middleName = record.middleName || '';
		const lastName = record.lastName || '';
		this.strApplicant = (firstName + ' ' + middleName + ' ' + lastName).replace(/\s+/g, ' ').trim();
		this.strCaseNumber = record.caseNumber;
		this.strCaseStatus = record.caseStatus;
		if (record.caseStatus === 'Open') {
			try {
				const dateCreated = new Date(record.dateOpened);
				const currentDate = new Date();
				const millisecondsPerDay = 1000 * 60 * 60 * 24;
				const daysPassed = Math.floor((currentDate.getTime() - dateCreated.getTime()) / millisecondsPerDay);
				this.strDaysOpen = daysPassed.toString();
			} catch (e) {
				console.log(e);
				this.strDaysOpen = 'N/A';
			}
		}

		this.id = record.id;

		this.selectedCaseId = this.selectedRecord.id;

		setTimeout(() => {
			switch (this.selectedTabLabel) {
				case 'Case':
					this.casedetails?.onShowHandler(this.selectedCaseId, this.selectedRecord, this.advocate);
					break;
				case 'Members':
					this.members?.onShowHandler(this.selectedCaseId, this.selectedRecord);
					break;
				case 'Documents':
					this.casedocuments?.onShowHandler(this.selectedCaseId, new ServiceRequest());
					break;
				case 'Case Requests':
					this.requestsTab?.onShowHandler(this.selectedRecord);
					break;
				case 'Qualifications':
					this.qualifications?.onShowHandler(null, this.selectedCaseId);
					break;
				case 'Activity':
					this.history?.onShowHandler('Cases', 'id', record.id.toString(), this.selectedRecord.id.toString());
					break;
			}
		}, 0);


		/** drawer (if it is open) **/
		if (this.propContainerState === true) {
			this.displayDrawerData();
		}
	}
	public getBackgroundColor(record: Case): string {
		if (!record) {
			return;
		}

	}
	public doChangeStatus(event: any): void {
		this.strCaseStatus = event.caseStatus;
		this.selectedRecord.dateClosed = event.dateClosed;
	}
	fileInputChange(fileInputEvent: any) {
		if (fileInputEvent.target.files[0] === undefined || fileInputEvent.target.files[0] === null) {
			return;
		}
		if (fileInputEvent.target.files[0].size > 409600) {
			Settings.getInstance().handleError('The image file size should not exceed 400KB');
			return;
		}

		this.selectedFile = fileInputEvent.target.files[0];
		this.valFilePath = this.selectedFile.name;
		this.loading = true;
		const tempImagePath: string = URL.createObjectURL(this.selectedFile);
		this.avatarURL = 'url(' + tempImagePath + ')';
		document.getElementById('avatar').style.backgroundImage = this.avatarURL;
		this.serviceRequestsService.updateCaseAvatarImage(this.selectedRecord.id, this.selectedFile).subscribe(
			(data) => {
				this.loading = false;
				this.doLoadAvatarImage();
			},
			(error) => {
				Settings.getInstance().handleError(error);
				this.loading = false;
			}
		);

	}
	doLoadAvatarImage() {
		this.imageAvatarFlag = false;
		if (!this.selectedRecord || !this.selectedRecord.id || this.selectedRecord.id < 1) {
			return;
		}
		this.serviceRequestsService.getCaseAvatarImage(this.selectedRecord.id).subscribe(
			(data1) => {
				const tempImagePath: string = URL.createObjectURL(data1);
				this.avatarURL = 'url(' + tempImagePath + ')';
				document.getElementById('avatar').style.backgroundImage = this.avatarURL;
				this.imageAvatarFlag = true;
			},
			(error1) => {
				this.imageAvatarFlag = false;
				this.avatarURL = 'url(' + this.placeHolderURL + ')';
				document.getElementById('avatar').style.backgroundImage = this.avatarURL;
			}
		);
	}

	public showCaseAvatarPreview() {

		this.visiblePreviewCaseAvatarDialog = true;
		this.previewCaseAvatar.onShowHandler(this.selectedRecord.id);
	}
	public hideCaseAvatarPreview() {
		this.visiblePreviewCaseAvatarDialog = false;
	}
	public doReloadMembers(): void {
		if (!this.selectedCaseId || this.selectedCaseId < 1) {
			return;
		}
		this.serviceRequestsService.getCaseById(this.selectedCaseId).subscribe(
			(result) => {
				this.selectedRecord = result;
				this.queryMemberRecords();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching Case');
			});
	}
}
